import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';

/** Traducciones cargadas bajo demanda (import dinámico): solo el idioma activo va al bundle. */
class TraduccionesLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<TranslationObject> {
    if (lang === 'eu') {
      return from(
        import('../../../assets/i18n/eu.json').then(
          (m) => (m as { default: TranslationObject }).default ?? (m as TranslationObject),
        ),
      );
    }
    return from(
      import('../../../assets/i18n/es.json').then(
        (m) => (m as { default: TranslationObject }).default ?? (m as TranslationObject),
      ),
    );
  }
}

/** Fábrica para `provideTranslateLoader`: reutilizable en app.config.ts. */
export function traduccionesLoaderFactory(): TranslateLoader {
  return new TraduccionesLoader();
}
